import { APPLICATION_ACTION_COMPELTE_STATUSES, APPLICATION_ACTION_SUBMITTED_STATUSES, APPLICATION_APPROACH, APPLICATION_STATUS } from "../enums/application.enum";
import { USER_ROLES } from "../enums/user.enum";
import { UserService } from "../services/user.service";
import { AppCertWizard } from "./app-cert-wizard.model";
import { Artifact } from "./artifact.model";
import { RoleArtifact } from "./role-artifacts.model";
export class IApplicationWizard extends AppCertWizard{
    appId!: string;
    userId!: string;
    applicantId!: string;
    siteIdPrimary!: string;
    siteIdSecondary!: string;
    systemCode!: string;
    siteCode!: string;
    startedBy!: string;
    originatorFirstName!: string;
    originatorLastName!: string;
    status?: { 
        Value: APPLICATION_STATUS,
        Display: string,
    } = { 
        Value: APPLICATION_STATUS.STARTED,
        Display:'Started'
    };
    approach: APPLICATION_APPROACH = APPLICATION_APPROACH.OTH;
    approachDisplay: string = '';
    feeAmount: number | null = null;
    feeAmountPaid: number | null = null;
    feeSummaries: any[] = [];
    startedDate: Date = new Date();
    submittedDate: Date | null = null;
    packageCompleteDate: Date | null = null;
    lastReviewDate: Date | null = null;
    reviewCompletedDate: Date | null = null;
    decisionDate: Date | null = null;
    user: any = null;
    firstName: string = "";
    lastName: string = "";
    documents: any = [];
    
    artifacts: Artifact[] = [];
    roleArtifacts: RoleArtifact[] = [];
    appExtensionsList: any;
    leaFinanceEmail: string = "";
    percentageComplete: number = 0;
    deadlineDays: number = 0;
    deadlineDate: Date | null = null;
    deadlineTotal: number = 180;
    deadlineRemain: number = 0;

    applicantSigned: boolean = false;
    actionableRoles: USER_ROLES[] = [];
    isActionPending: boolean = false; //use in frontend only
    waitingRole?: 'Applicant'|'Agency' = undefined; //use in frontend only

    // Config-driven per-approach agent capabilities (resolved server-side from ApproachProfile).
    // Gate the Deny / Request-Resubmit actions so they can be toggled per approach without UI code changes.
    isDeniable: boolean = false;
    isRejectable: boolean = false;
}
export class ApplicationWizard extends IApplicationWizard {

    constructor(userService:UserService, options?: IApplicationWizard) {
        super();
        if (options) {
            this.appId = options.appId ?? this.appId;
            this.userId = options.userId ?? this.userId;
            this.applicantId = options.applicantId ?? this.applicantId;
            this.siteIdPrimary = options.siteIdPrimary ?? this.siteIdPrimary;
            this.siteIdSecondary = options.siteIdSecondary ?? this.siteIdSecondary;
            this.systemCode = options.systemCode ?? this.systemCode;
            this.siteCode = options.siteCode ?? this.siteCode;
            this.startedBy = options.startedBy ?? this.startedBy;
            this.originatorFirstName = options.originatorFirstName ?? this.originatorFirstName;
            this.originatorLastName = options.originatorLastName ?? this.originatorLastName;
            this.status = { 
                Value: options.status?.Value ? options.status?.Value : APPLICATION_STATUS.STARTED,
                Display: options.status?.Display ? options.status?.Display : 'Started',
             };
            this.approach = options.approach ?? this.approach;
            this.approachDisplay = options.approachDisplay ? options.approachDisplay : this.approach;
            this.feeSummaries = options.feeSummaries ?? this.feeSummaries;
            this.startedDate = options.startedDate ? new Date(options.startedDate) : this.startedDate;
            this.submittedDate = options.submittedDate ? new Date(options.submittedDate) : this.submittedDate;
            this.packageCompleteDate = options.packageCompleteDate ? new Date(options.packageCompleteDate) : this.packageCompleteDate;
            this.lastReviewDate = options.lastReviewDate ? new Date(options.lastReviewDate) : this.lastReviewDate;
            this.reviewCompletedDate = options.reviewCompletedDate ? new Date(options.reviewCompletedDate) : this.reviewCompletedDate;
            this.decisionDate = options.decisionDate ? new Date(options.decisionDate) : this.decisionDate;
            this.user = options.user ?? this.user;
            this.firstName = options.firstName ?? this.firstName;
            this.lastName = options.lastName ?? this.lastName;
            this.user = options.user ?? this.user;
            this.leaFinanceEmail = options.leaFinanceEmail ?? this.leaFinanceEmail;
            this.actionableRoles = options.actionableRoles ?? this.actionableRoles;
            this.appExtensionsList = options.appExtensionsList ?? this.appExtensionsList;
            this.percentageComplete = options.percentageComplete ?? this.percentageComplete;
            this.deadlineDays = options.deadlineDays ?? this.deadlineDays;
            this.deadlineDate = options.deadlineDate ? new Date(options.deadlineDate) : this.deadlineDate;
            this.applicantSigned = options.applicantSigned ?? this.applicantSigned;
            this.isDeniable = options.isDeniable ?? this.isDeniable;
            this.isRejectable = options.isRejectable ?? this.isRejectable;

            if (!(this.appExtensionsList.length > 0)) {
                this.appExtensionsList = [];
                this.appExtensionsList.push({
                    "appType": "TEAMS",
                    "properties": {}
                });
            }
            if (this.feeSummaries.length) {
                this.feeSummaries.forEach((feeSummary) => {
                    feeSummary.items.map((item: any) => {
                        this.feeAmount += item.feeAmount;
                        this.feeAmountPaid += item.feeAmountPaid;
                    }, 0);
                });
            }
            if (options.documents) {
                options.documents.forEach((value: any) => {
                    this.documents?.push(value)
                })
            }
            if (options.artifacts) {
                options.artifacts.forEach(value => {
                    this.artifacts?.push(new Artifact(value))
                })
            }
            if (options.roleArtifacts) {
                options.roleArtifacts.forEach(value => {
                    this.roleArtifacts?.push(new RoleArtifact(value))
                })
            }
            this.calculateIsActionPending(userService);
            this.calculateWaitingRole();
            this.calculateDeadlines();
            this.setAgentResponsibilityText(this.artifacts);
            
        }
    }

    isApproachLEArenewal() {
        return this.approach.toLowerCase() == APPLICATION_APPROACH.LEA_RENEWAL.toLowerCase();
    }

    isResubmitableApplication() {
        return ![
            APPLICATION_APPROACH.OTH.toLowerCase(),
            APPLICATION_APPROACH.CBT.toLowerCase(),
            APPLICATION_APPROACH.CTF.toLowerCase(),
            APPLICATION_APPROACH.RTF.toLowerCase(),
            APPLICATION_APPROACH.TEAMS.toLowerCase(),
        ].includes(this.approach.toLowerCase());
    }

    calculateIsActionPending(userService:UserService){
        const user = userService.getUser()
        let isActionPending = (this.actionableRoles || []).find((requireRole: USER_ROLES) => { return user.selectedSiteRole.RoleName.toUpperCase() == requireRole.toUpperCase() });
        if (isActionPending) {
            this.isActionPending = true;
        }
    }
    calculateWaitingRole(){
        let isApplicant = (this.actionableRoles || []).find((role: USER_ROLES) => { return USER_ROLES.APPLICANT == role.toUpperCase() });
        let isAgent = (this.actionableRoles || []).find((role: USER_ROLES) => { return USER_ROLES.APPLICANT !== role.toUpperCase() });
        if (isApplicant) {
            this.waitingRole = 'Applicant';
        }
        else if(isAgent){
            this.waitingRole = 'Agency';
        }
    }
    calculateDeadlines() {
        if(this.deadlineDate){
            this.deadlineRemain = this.dateDiffInDays(new Date(this.deadlineDate), new Date());
            this.deadlineRemain = this.deadlineRemain > 0 ? this.deadlineRemain : 0;
        }
    }

    hasExpiry(){
        return [
            APPLICATION_STATUS.STARTED,
            APPLICATION_STATUS.MOREINFO,
            APPLICATION_STATUS.SUBMITTED
        ].includes(this.status?.Value || APPLICATION_STATUS.STARTED);
    }
    hasDeadline(){
        return [
            APPLICATION_STATUS.STARTED,
            APPLICATION_STATUS.MOREINFO,
            APPLICATION_STATUS.SUBMITTED,
            APPLICATION_STATUS.EXPIRED,
        ].includes(this.status?.Value || APPLICATION_STATUS.STARTED);
    }

    dateDiffInDays(last: Date, start: Date) {
        const diffTime = Math.abs(last.getTime() - start.getTime());
        const diffDays = Math.ceil(diffTime / (1000 * 60 * 60 * 24));
        return diffDays < 500 ? diffDays : 0;
    }

    toJSON() {
        return {
            appId: this.appId,
            userId: this.userId,
            applicantId: this.applicantId,
            siteIdPrimary: this.siteIdPrimary,
            siteIdSecondary: this.siteIdSecondary,
            systemCode: this.systemCode,
            siteCode: this.siteCode,
            startedBy: this.startedBy,
            originatorFirstName: this.originatorFirstName,
            originatorLastName: this.originatorLastName,
            status: this.status,
            approach: this.approach,
            approachDisplay: this.approachDisplay,
            feeAmount: this.feeAmount,
            feeAmountPaid: this.feeAmountPaid,
            feeSummaries: this.feeSummaries,
            startedDate: this.startedDate,
            submittedDate: this.submittedDate,
            packageCompleteDate: this.packageCompleteDate,
            lastReviewDate: this.lastReviewDate,
            reviewCompletedDate: this.reviewCompletedDate,
            decisionDate: this.decisionDate,
            user: this.user,
            firstName: this.firstName,
            lastName: this.lastName,
            leaFinanceEmail: this.leaFinanceEmail,
            documents: this.documents,
            actionableRoles: this.actionableRoles,
            appExtensionsList: this.appExtensionsList,
            percentageComplete: this.percentageComplete,
            deadlineDays: this.deadlineDays,
            deadlineDate: this.deadlineDate,
            applicantSigned: this.applicantSigned,
            isDeniable: this.isDeniable,
            isRejectable: this.isRejectable,
            artifacts: this.artifacts.map(i => i.toJSON()),
            roleArtifacts: this.roleArtifacts.map(i => i.toJSON()),
        }
    }
}